const ENVIRONMENT_PATTERN = /^(development|test|ci|staging|production)$/;

export const resolveAdminEnvironment = ({ apiBaseUrl, environment }) => {
  const environmentName = String(environment || "")
    .trim()
    .toLowerCase();
  if (!ENVIRONMENT_PATTERN.test(environmentName)) {
    throw new Error(
      "REACT_APP_ENVIRONMENT must be one of development, test, ci, staging, or production",
    );
  }

  const rawBaseUrl = String(apiBaseUrl || "").trim();
  if (!rawBaseUrl) {
    throw new Error("REACT_APP_API_BASE_URL is required");
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(rawBaseUrl);
  } catch {
    throw new Error("REACT_APP_API_BASE_URL must be an absolute HTTP(S) URL");
  }

  if (!["http:", "https:"].includes(parsedUrl.protocol)) {
    throw new Error("REACT_APP_API_BASE_URL must use HTTP or HTTPS");
  }
  if (parsedUrl.username || parsedUrl.password) {
    throw new Error("REACT_APP_API_BASE_URL must not contain credentials");
  }
  if (parsedUrl.search || parsedUrl.hash) {
    throw new Error(
      "REACT_APP_API_BASE_URL must not contain query parameters or fragments",
    );
  }
  if (environmentName === "production" && parsedUrl.protocol !== "https:") {
    throw new Error("Production admin API configuration requires HTTPS");
  }

  return Object.freeze({
    apiBaseUrl: parsedUrl.toString().replace(/\/+$/, ""),
    environment: environmentName,
    apiHost: parsedUrl.host,
  });
};

export const adminEnvironment = resolveAdminEnvironment({
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
});
